<template>
  <bkf-action
    :disabled="disabled"
    :tooltip="$trans('v2.i2m_components.actions.download')"
    @click="$emit('click')"
  >
    <v-icon>
      mdi-cloud-download
    </v-icon>
  </bkf-action>
</template>

<script>

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
